module.exports = __webpack_public_path__ + "img/p2-48.c00e3a27.png";